import ACTION_TYPE from '../../store/ACTION_TYPE';
import createReducerFunction from '../../store/reducerCreator';
import APP_SETTINGS_STATUS_ACTION from '../../enums/APP_SETTINGS_STATUS_ACTION';

interface State {
    appId?: string;
    name?: string;
    settingsURL?: string;
    token?: string;
    saveUrl?: string;
    domain?: string;
    isFetching: boolean;
}

const initialState: State = {
    isFetching: false,
};

interface Action {
    type:
        | ACTION_TYPE.OPEN_SETTINGS_INFO_POPUP
        | ACTION_TYPE.APP_SETTINGS_CHANGED_FULFILLED
        | ACTION_TYPE.REQUEST_USER_SETTINGS_TOKEN_PENDING
        | ACTION_TYPE.REQUEST_USER_SETTINGS_TOKEN_FULFILLED
        | ACTION_TYPE.REQUEST_USER_SETTINGS_TOKEN_REJECTED
        | ACTION_TYPE.CLOSE_SETTINGS_INFO_POPUP;
    payload: {
        appId?: string;
        name?: string;
        settingsURL?: string;
        token?: string;
        saveUrl?: string;
        domain?: string;
        statusAction?: string;
    };
}

export default createReducerFunction<State, Action>({
    initialState,
    reducers: {
        [ACTION_TYPE.OPEN_SETTINGS_INFO_POPUP]: initAppSettingsFromInfo,
        [ACTION_TYPE.APP_SETTINGS_CHANGED_FULFILLED]: initAppSettingsFromStatus,
        [ACTION_TYPE.REQUEST_USER_SETTINGS_TOKEN_PENDING]: (state) => ({ ...state, isFetching: true }),
        [ACTION_TYPE.REQUEST_USER_SETTINGS_TOKEN_FULFILLED]: (state, { payload }) => ({
            ...state,
            token: payload.token,
            saveUrl: payload.saveUrl,
            domain: payload.domain,
            isFetching: false,
        }),
        [ACTION_TYPE.REQUEST_USER_SETTINGS_TOKEN_REJECTED]: () => initialState,
        [ACTION_TYPE.CLOSE_SETTINGS_INFO_POPUP]: () => initialState,
    },
});

function initAppSettingsFromInfo(state: State, { payload }: Action) {
    return { ...state, appId: payload.appId, name: payload.name, settingsURL: payload.settingsURL };
}

function initAppSettingsFromStatus(state: State, { payload }: Action) {
    if (
        payload.statusAction === APP_SETTINGS_STATUS_ACTION.ADD_APP ||
        payload.statusAction === APP_SETTINGS_STATUS_ACTION.ENABLE_APP_GROUP
    ) {
        return { ...state, appId: payload.appId, name: payload.name, settingsURL: payload.settingsURL };
    }

    return state;
}
